export default __webpack_public_path__ + "static/media/zhang.2a3d13cb.jpg";